<template>
  <div class="page404">
    <corner-box class="panel">
      <div class="content">
        <div class="arrow">▲</div>
        <div class="code">404</div>
        <div class="split"></div>
        <div class="headline">电梯没有停靠这一层</div>
        <div class="info">请检查您输入的网址是否正确，{{ countdown }} 秒后自动返回</div>
        <div class="path">访问地址：{{ badPath }}</div>
        <div class="btns">
          <span class="btn" @click="goHome">立即返回</span>
          <span class="btn ghost" @click="goBack">返回上一页</span>
        </div>
      </div>
    </corner-box>
  </div>
</template>

<script>
import CornerBox from '@/views/bigscreen/ruijin/components/CornerBox.vue'

const BACK_SECONDS = 10

export default {
  name: 'Page404',
  components: { CornerBox },
  data() {
    return {
      countdown: BACK_SECONDS,
      timer: null
    }
  },
  computed: {
    // 通配符兜底是redirect过来的，此时fullPath已经变成/404，原始地址在redirectedFrom里
    badPath() {
      return this.$route.redirectedFrom || this.$route.fullPath
    }
  },
  created() {
    // 大屏常年无人值守，停在错误页不如自己回去
    this.timer = setInterval(() => {
      this.countdown -= 1
      if (this.countdown <= 0) {
        this.goHome()
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    // 落地规则与外链登录一致：ask账号菜单树只有大屏，而大屏父级自身没有内容，必须落到它的第一个子页
    goHome() {
      clearInterval(this.timer)
      const menus = this.$store.getters['menu/getArrJurisdiction'] || []
      const first = menus[0]
      if (!first) {
        this.$router.replace('/login')
        return
      }
      if (first.functionId === 'BigScreen') {
        const pages = first.children || []
        const page = pages.find((item) => item.status !== '1') || pages[0]
        this.$router.replace(page ? `/${page.functionId}` : '/login')
        return
      }
      this.$router.replace('/index')
    },
    goBack() {
      clearInterval(this.timer)
      // 外链跳入时历史里可能没有可回的页面
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.goHome()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page404 {
  /* 该页不挂在任何布局下，body的深色底只在大屏页加载过bigScreen样式后才有，这里自带一份 */
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #070f29;
  background-image: radial-gradient(circle at 50% 38%, rgba(11, 58, 122, 0.55), rgba(7, 15, 41, 0) 62%),
    repeating-linear-gradient(to right, rgba(26, 75, 139, 0.16) 0 1px, rgba(7, 15, 41, 0) 1px 60px),
    repeating-linear-gradient(to bottom, rgba(26, 75, 139, 0.16) 0 1px, rgba(7, 15, 41, 0) 1px 60px);
}

.panel {
  width: 620px;
  max-width: 92%;
}

.content {
  padding: 46px 40px 40px;
  text-align: center;
  color: #ffffff;
}

.arrow {
  font-size: 22px;
  color: #00d9fb;
  animation: floatUp 1.8s ease-in-out infinite;
}

.code {
  margin-top: 6px;
  font-size: 104px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 10px;
  text-indent: 10px; /* 抵消最后一个字符的字距，保持视觉居中 */
  color: #00deff;
  text-shadow: 0 0 18px rgba(0, 198, 255, 0.6), 0 0 60px rgba(0, 198, 255, 0.25);
}

.split {
  width: 68%;
  height: 2px;
  margin: 24px auto 20px;
  background-image: linear-gradient(to right, rgba(2, 195, 231, 0), #02c3e7, rgba(2, 195, 231, 0));
}

.headline {
  font-size: 22px;
  font-weight: bold;
}

.info {
  margin-top: 12px;
  font-size: 15px;
  color: #5293f4;
}

.path {
  margin-top: 8px;
  font-size: 13px;
  color: #3f6fb8;
  word-break: break-all;
}

.btns {
  margin-top: 30px;
  text-align: center;
}

.btn {
  display: inline-block;
  min-width: 132px;
  height: 42px;
  line-height: 42px;
  padding: 0 18px;
  font-size: 15px;
  color: #010d34;
  cursor: pointer;
  background-image: linear-gradient(to right, #00ffff, #00aff8);

  & + & {
    margin-left: 18px;
  }

  &:hover {
    filter: brightness(1.12);
  }

  &.ghost {
    height: 40px;
    line-height: 38px;
    color: #00d9fb;
    background-image: none;
    background-color: transparent;
    border: 1px solid #02c3e7;
    box-shadow: inset 0 0 18px rgba(0, 198, 255, 0.2);
  }
}

@keyframes floatUp {

  0%,
  100% {
    transform: translateY(4px);
    opacity: 0.4;
  }

  50% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
</style>
